import { useEffect } from 'react';
import { useRequest } from 'ahooks';
import { ImageProps } from 'antd';
import { AxiosResponse } from 'axios';
import { StringifiableRecord } from 'query-string';

import { apiGet } from 'api';

import { useGetHeaders, useMemoState } from 'hooks';

import { config } from 'miles.config';

import { MilesImage } from '../MilesImage';

export const FetchImage = ({
  alt,
  src,
  isNew,
  imgId,
  width,
  height,
  preview,
  className,
  isFullHeight = true,
}: ImageProps & { imgId?: string; isFullHeight?: boolean; isNew?: boolean; }) => {
  const [img, setImg] = useMemoState('');

  const headers = useGetHeaders();
  const srcOrId = src || imgId;
  const isVerifyUrl = src?.startsWith('https://scdn.veryfi');

  useRequest<AxiosResponse<Blob>, [StringifiableRecord]>(
    () => {
      const url = (imgId ? `${config.apiURL}/images/${imgId}` : src) as string;

      return apiGet({ url, headers, responseType: 'blob' });
    },
    {
      ready: !!srcOrId && !isVerifyUrl && !isNew,
      cacheKey: srcOrId,
      refreshDeps: [src, imgId],
      onError: () => setImg(''),
      onSuccess: ({ data }) => {
        const blobURL = URL.createObjectURL(data);

        setImg(blobURL);
      },
    },
  );

  useEffect(() => {
    if (isVerifyUrl) {
      setImg(src);
    }
  }, [isVerifyUrl]);

  return (
    <MilesImage
      alt={alt}
      src={img}
      isNew={isNew}
      width={width}
      height={height}
      preview={preview}
      className={className}
      isFullHeight={isFullHeight}
    />
  );
};
